// Helpers puros de seleção de linhas (imutáveis) — testáveis sem DOM.

// Alterna a marcação de um id, retornando um novo Set.
export const toggleSelection = (
  selected: ReadonlySet<string>,
  id: string
): Set<string> => {
  const next = new Set(selected)
  if (next.has(id)) {
    next.delete(id)
  } else {
    next.add(id)
  }
  return next
}

// Seleciona todos os ids informados (novo Set).
export const selectAll = (
  ids: readonly string[]
): Set<string> => new Set(ids)

// Limpa a seleção (novo Set vazio).
export const clearSelection = (): Set<string> => new Set()

// Verdadeiro quando há ids e todos estão marcados.
export const areAllSelected = (
  ids: readonly string[],
  selected: ReadonlySet<string>
): boolean =>
  ids.length > 0 && ids.every((id) => selected.has(id))
